// ErrorScreen.tsx
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ReportProblemOutlined } from "@mui/icons-material";

const ErrorScreen: React.FC = () => {
  const handleReload = () => {
    window.location.reload();
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#ffffff",
        color: "#721c24",
      }}
    >
      <Box
        sx={{ maxWidth: "800px", 
          display: "flex", 
          flexDirection: "column", 
          justifyContent: "center", 
          alignItems: "center" }}
      >
        <ReportProblemOutlined color="primary" sx={{width:'100px', height:'100px', color:'primary'}}/>
        <Typography variant="h4" component="h1" color="primary" gutterBottom sx={{ textAlign: "center", padding: "20px" }}>
          Unexpected Error Occured!
        </Typography>
        <Typography variant="h6" component="h6" color="primary" gutterBottom sx={{ textAlign: "center", padding: "20px" }}>
          Oops! Something went wrong, but don't worry – our team is already working on a fix. In the meantime, you can easily
          get back to your previous view by reloading the page using the link below. Thanks for your patience!
        </Typography>
        <Button variant="contained" color="primary" onClick={handleReload}>
          Go Back
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorScreen;
